/**
 * Pass text from the converter page to the text editor across a route change.
 * sessionStorage keeps it tab-local and it is removed as soon as it is read.
 */
const IMPORT_KEY = 'p2t-editor-import';

export const EDITOR_PATH = '/text-editor';

/** localStorage key holding the editor's autosaved draft. */
export const EDITOR_DRAFT_KEY = 'p2t-editor-draft';

export const readEditorDraft = (): string => {
  try {
    return localStorage.getItem(EDITOR_DRAFT_KEY) ?? '';
  } catch {
    return '';
  }
};

export const stashTextForEditor = (text: string): boolean => {
  try {
    sessionStorage.setItem(IMPORT_KEY, text);
    return true;
  } catch {
    return false;
  }
};

export const takeStashedEditorText = (): string | null => {
  try {
    const value = sessionStorage.getItem(IMPORT_KEY);
    if (value !== null) sessionStorage.removeItem(IMPORT_KEY);
    return value;
  } catch {
    return null;
  }
};
